import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";
import { URLS } from "@const/urls";

export interface IProps {
  name: string;
  showIcon: boolean;
  goToUrl?: string;
  className?: string | classNames.ArgumentArray;
}

function LinkMenu({ name, goToUrl = URLS.HOME, showIcon, className }: IProps) {
  return (
    <Link className={classNames("flex items-center whitespace-nowrap", className)} to={goToUrl}>
      {showIcon ? <Icon name={IconName.Default_700} /> : null}
      <span className="h-4.5">{name.replace(/\b[a-z]/g, (char) => char.toUpperCase())}</span>
    </Link>
  );
}

export default LinkMenu;
